import React from 'react';
import classnames from 'classnames';

import { ILink } from 'utils/types';
import { Link } from 'components/link/Link';
import { ChevronRight } from 'components/assets';

import s from './BackButton.module.scss';

type Props = {
  color?: 'brand' | 'white' | 'dark' | string;
  staticColor?: boolean;
  link?: ILink;
  href?: string;
  onClick?: (event?) => void;
  children: React.ReactNode;
  [rest: string]: any;
};

export const BackButton = ({
  color = 'white',
  link,
  href,
  staticColor,
  children,
  ...rest
}: Props) => {
  const className = classnames(s.button, {
    [s.brand]: color === 'brand',
    [s.white]: color === 'white',
    [s.dark]: color === 'dark',
    [s.static]: staticColor,
  });
  const content = (
    <span className={s.button__content}>
      <span className={s.button__icon}>
        <ChevronRight />
      </span>
      <span className={s.button__text}>{children || 'Back'}</span>
    </span>
  );

  if (href) {
    return (
      <Link className={className} href={href} {...rest}>
        {content}
      </Link>
    );
  }

  return (
    <button className={className} {...rest}>
      {content}
    </button>
  );
};
